module.exports = __webpack_public_path__ + "static/money-b91dde93d1f1e1f48d5bc88915c4bd2e.png";